var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _c("Aggregate", {
            attrs: {
              title: "Demand Response",
              "error-messages": _vm.errorMessages,
              ItemConstructor: _vm.demandFactory,
              "allow-edit": false,
            },
            on: {
              change: function ($event) {
                return _vm.$emit("change")
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var item = ref.item
                  var errors = ref.errors
                  return [
                    _c("InputToggleParam", {
                      attrs: {
                        label:
                          _vm.schema.operating_status.properties.active.title,
                        hint: _vm.schema.operating_status.properties.active
                          .tooltip,
                        "error-messages": _vm.$utils.getIfExists(errors, [
                          "operating_status",
                        ]),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$emit("change")
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var param = ref.param
                              return [
                                _c("InputProfile", {
                                  attrs: {
                                    hint: _vm.schema.operating_status.then
                                      .properties.param.properties.id.tooltip,
                                    "profile-type": "DAILY_OPERATING_STATUS",
                                    "hide-divider": "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value: param.id,
                                    callback: function ($$v) {
                                      _vm.$set(param, "id", $$v)
                                    },
                                    expression: "param.id",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: item.operating_status,
                        callback: function ($$v) {
                          _vm.$set(item, "operating_status", $$v)
                        },
                        expression: "item.operating_status",
                      },
                    }),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", lg: "6" } },
                          [
                            _c("InputYearly", {
                              attrs: {
                                label: _vm.schema.power_capacity.title,
                                hint: _vm.schema.power_capacity.tooltip,
                                "error-messages": _vm.$utils.getIfExists(
                                  errors,
                                  ["power_capacity"]
                                ),
                                suffix: _vm.schema.power_capacity.unit,
                                num_years: _vm.num_years,
                                "start-year": _vm.startYear,
                                type: "number",
                                fill: "",
                                "fill-value":
                                  _vm.schema.power_capacity.items.default,
                                "chart-visible": "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("change")
                                },
                              },
                              model: {
                                value: item.power_capacity,
                                callback: function ($$v) {
                                  _vm.$set(item, "power_capacity", $$v)
                                },
                                expression: "item.power_capacity",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", lg: "6" } },
                          [
                            _c("InputYearly", {
                              attrs: {
                                label: _vm.schema.energy_costs.title,
                                hint: _vm.schema.energy_costs.tooltip,
                                "error-messages": _vm.$utils.getIfExists(
                                  errors,
                                  ["energy_costs"]
                                ),
                                suffix: _vm.schema.energy_costs.unit,
                                num_years: _vm.num_years,
                                "start-year": _vm.startYear,
                                type: "number",
                                fill: "",
                                "fill-value":
                                  _vm.schema.energy_costs.items.default,
                                "chart-visible": "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("change")
                                },
                              },
                              model: {
                                value: item.energy_costs,
                                callback: function ($$v) {
                                  _vm.$set(item, "energy_costs", $$v)
                                },
                                expression: "item.energy_costs",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", lg: "6" } },
                          [
                            _c("InputYearly", {
                              attrs: {
                                label: _vm.schema.investment_cost.title,
                                hint: _vm.schema.investment_cost.tooltip,
                                "error-messages": _vm.$utils.getIfExists(
                                  errors,
                                  ["investment_cost"]
                                ),
                                suffix: _vm.schema.investment_cost.unit,
                                num_years: _vm.num_years,
                                "start-year": _vm.startYear,
                                type: "number",
                                fill: "",
                                "fill-value":
                                  _vm.schema.investment_cost.items.default,
                                "chart-visible": "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("change")
                                },
                              },
                              model: {
                                value: item.investment_cost,
                                callback: function ($$v) {
                                  _vm.$set(item, "investment_cost", $$v)
                                },
                                expression: "item.investment_cost",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", lg: "6" } },
                          [
                            _c("InputYearly", {
                              attrs: {
                                label: _vm.schema.maximum_capacity.title,
                                hint: _vm.schema.maximum_capacity.tooltip,
                                "error-messages": _vm.$utils.getIfExists(
                                  errors,
                                  ["maximum_capacity"]
                                ),
                                suffix: _vm.schema.maximum_capacity.unit,
                                num_years: _vm.num_years,
                                "start-year": _vm.startYear,
                                type: "number",
                                fill: "",
                                "fill-value":
                                  _vm.schema.maximum_capacity.items.default,
                                "chart-visible": "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("change")
                                },
                              },
                              model: {
                                value: item.maximum_capacity,
                                callback: function ($$v) {
                                  _vm.$set(item, "maximum_capacity", $$v)
                                },
                                expression: "item.maximum_capacity",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", lg: "6" } },
                          [
                            _c("InputYearly", {
                              attrs: {
                                label: _vm.schema.maximum_build.title,
                                hint: _vm.schema.maximum_build.tooltip,
                                "error-messages": _vm.$utils.getIfExists(
                                  errors,
                                  ["maximum_build"]
                                ),
                                suffix: _vm.schema.maximum_build.unit,
                                num_years: _vm.num_years,
                                "start-year": _vm.startYear,
                                type: "number",
                                fill: "",
                                "fill-value":
                                  _vm.schema.maximum_build.items.default,
                                "chart-visible": "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("change")
                                },
                              },
                              model: {
                                value: item.maximum_build,
                                callback: function ($$v) {
                                  _vm.$set(item, "maximum_build", $$v)
                                },
                                expression: "item.maximum_build",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", lg: "6" } },
                          [
                            _c("v-text-field", {
                              staticClass: "my-4",
                              attrs: {
                                label:
                                  _vm.schema.max_reserve_participation.title,
                                hint: _vm.schema.max_reserve_participation
                                  .tooltip,
                                "error-messages": _vm.$utils.getIfExists(
                                  errors,
                                  ["max_reserve_participation", "messages"]
                                ),
                                suffix:
                                  _vm.schema.max_reserve_participation.unit,
                                type: "number",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("change")
                                },
                              },
                              model: {
                                value: item.max_reserve_participation,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item,
                                    "max_reserve_participation",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "item.max_reserve_participation",
                              },
                            }),
                            _c("v-text-field", {
                              staticClass: "my-4",
                              attrs: {
                                label: _vm.schema.max_utilization.title,
                                hint: _vm.schema.max_utilization.tooltip,
                                "error-messages": _vm.$utils.getIfExists(
                                  errors,
                                  ["max_utilization", "messages"]
                                ),
                                suffix: _vm.schema.max_utilization.unit,
                                type: "number",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("change")
                                },
                              },
                              model: {
                                value: item.max_utilization,
                                callback: function ($$v) {
                                  _vm.$set(item, "max_utilization", _vm._n($$v))
                                },
                                expression: "item.max_utilization",
                              },
                            }),
                            _c("v-text-field", {
                              staticClass: "my-4",
                              attrs: {
                                label: _vm.schema.ramp_rate.title,
                                hint: _vm.schema.ramp_rate.tooltip,
                                "error-messages": _vm.$utils.getIfExists(
                                  errors,
                                  ["ramp_rate", "messages"]
                                ),
                                suffix: _vm.schema.ramp_rate.unit,
                                type: "number",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("change")
                                },
                              },
                              model: {
                                value: item.ramp_rate,
                                callback: function ($$v) {
                                  _vm.$set(item, "ramp_rate", _vm._n($$v))
                                },
                                expression: "item.ramp_rate",
                              },
                            }),
                            _c("InputReserve", {
                              attrs: {
                                label: _vm.schema.reserve_participation.title,
                                hint: _vm.schema.reserve_participation.tooltip,
                                "error-messages": _vm.$utils.getIfExists(
                                  errors,
                                  ["reserve_participation"]
                                ),
                                reserves: _vm.reserves,
                                suffix: "%",
                                type: "number",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("change")
                                },
                              },
                              model: {
                                value: item.reserve_participation,
                                callback: function ($$v) {
                                  _vm.$set(item, "reserve_participation", $$v)
                                },
                                expression: "item.reserve_participation",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.computedValue,
              callback: function ($$v) {
                _vm.computedValue = $$v
              },
              expression: "computedValue",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }